import { useLang } from '../contexts/LanguageContext';
import { LANGUAGES } from '../translations';

/**
 * Switch de langue minimaliste : FR | EN
 *
 * Props :
 * - variant: 'desktop' | 'mobile' (rendu adapté au contexte)
 * - colorScheme: 'light' (texte clair) | 'dark' (texte sombre)
 */
export default function LanguageSwitcher({ variant = 'desktop', colorScheme = 'light' }) {
  const { lang, setLang } = useLang();

  const baseColor = colorScheme === 'light' ? 'text-white/50 hover:text-white' : 'text-gray-400 hover:text-gray-900';
  const activeColor = colorScheme === 'light' ? 'text-white' : 'text-gray-900';
  const separator = colorScheme === 'light' ? 'text-white/20' : 'text-gray-300';

  if (variant === 'mobile') {
    return (
      <div className="flex items-center gap-3 text-sm tracking-[0.15em] uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
        {LANGUAGES.map((l, i) => (
          <span key={l.code} className="flex items-center gap-3">
            {i > 0 && <span className="text-white/20">|</span>}
            <button
              type="button"
              onClick={() => setLang(l.code)}
              className={`transition-colors duration-200 font-normal ${
                lang === l.code ? 'text-white' : 'text-white/45 hover:text-white/80'
              }`}>
              {l.label}
            </button>
          </span>
        ))}
      </div>
    );
  }

  // variant === 'desktop'
  return (
    <div className="flex items-center gap-2 text-[11px] tracking-[0.15em]" style={{ fontFamily: "'Inter', sans-serif" }}>
      {LANGUAGES.map((l, i) => (
        <span key={l.code} className="flex items-center gap-2">
          {i > 0 && <span className={separator}>|</span>}
          <button
            type="button"
            onClick={() => setLang(l.code)}
            className={`transition-colors duration-300 ${
              lang === l.code ? activeColor : baseColor
            }`}>
            {l.label}
          </button>
        </span>
      ))}
    </div>
  );
}
